var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-18270ecb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector?type=styles&index=0!./UserRoles.vue")
}
var normalizeComponent = require("!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./UserRoles.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./UserRoles.vue"
/* template */
import __vue_template__ from "!!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-18270ecb\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector?type=template&index=0!./UserRoles.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Users/UserRoles.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18270ecb", Component.options)
  } else {
    hotAPI.reload("data-v-18270ecb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Users/UserRoles.vue
// module id = null
// module chunks = 